<template>
    <span :class="['btn view', FocusState(view)]" @click="$emit('toggle', view)">{{ view }}</span>
</template>

<script>
export default {
    name: "ViewToggleType",
    props: {
        view: String,
        current: String
    },
    methods: {
        FocusState: function(view) {
            if (this.current === view) {
                return "disabled view-active";
            }
            return "";
        }
    },
    emits: [ "toggle" ]
};
</script>